/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — thin route for the RSVP confirm/decline page; delegates
 *              data loading to the controller
 *   extends:   Route
 *   template:  none
 *   model:     - (empty model())
 *   key:       beforeModel (locale + session.bootstrapSession), setupController
 *              (perform loadDataTask), resetController (cancelAll loadDataTask)
 *   uses:      session/intl services
 *   siblings:  controllers/confirm.js, templates/confirm.hbs
 *   tests:     wave5-coverage-test.js
 *
 * Bootstraps the anonymous session then hands off to
 * ConfirmController#loadDataTask, which fetches the event's confirmation info.
 */
import Route from '@ember/routing/route';
import { inject as iService } from '@ember/service';

export default class ConfirmRoute extends Route {
  @iService session;
  @iService intl;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    this.intl.setLocale(['en-US', 'en-GB', 'it-IT', 'fr-FR', 'de-DE']);

    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
